export default __webpack_public_path__ + "1020a0aa83f58bcb205328a98107740b.svg";